import { render, staticRenderFns } from "./product-page-overlays.vue?vue&type=template&id=93060010&"
import script from "./product-page-overlays.vue?vue&type=script&lang=ts&"
export * from "./product-page-overlays.vue?vue&type=script&lang=ts&"
import style0 from "../../../assets/scss/typography.scss?vue&type=style&index=0&lang=scss&module=styleTypography&"
import style1 from "./product-page-overlays.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleTypography"] = (style0.locals || style0)
this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports